module.exports = __webpack_public_path__ + "img/main.2c661e99.png";